import { Component, Input } from '@angular/core';

import { ContactFormService } from './contact-form.service';

@Component({
  selector: 'contact-form',
  template: require('./contact-form.component.html'),
  styles: [require('./contact-form.component.scss')],
  providers: [ContactFormService]
})
export class ContactFormComponent {

  @Input()
  set type(emailType: string) {
    this.service.setType(emailType);
  }

  constructor(private service: ContactFormService) {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/contact-form/contact-form.component.ts